import Menu from './components/Menu';
import HomeHero from './components/HomeHero';
import Slider from './components/NewsCardsSlider';

window.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('[data-diganl-header]');
	if (header) {
		new Menu(header);
	}

	const homeHero = document.querySelector('[data-diganl-home-hero]');
	if (homeHero) {
		new HomeHero(homeHero);
	}

	const newsCardsSliders = document.querySelectorAll('[data-diganl-news-cards-slider]');
	if (newsCardsSliders.length) {
		newsCardsSliders.forEach((slider) => {
			new Slider(slider);
		});
	}
});
